// extracted by mini-css-extract-plugin
export var numpadContainer = "_nn-1";
export var phoneButton = "_nn-0";